import React from 'react'
import OwlCarousel from 'react-owl-carousel';

function OurDoners() {

    const content = [
        {
            image: require('../../../Static/img/cavaliers.jpeg')
        },
        {
            image: require('../../../Static/img/guitarDrive.png')
        },
        {
            image: require('../../../Static/img/dagdi_logo.png')
        },
        {
            image: require('../../../Static/img/yupmedi.svg')
        },
        {
            image: require('../../../Static/img/appbuddy.png')
        },
    ];

    return (
        <div className="cta-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="sec-title">
                            <h2>Who helped us<br/><br/><br/></h2>
                        </div>
                        <OwlCarousel className="logo-carousel owl-carousel"
                            loop={true}
                            autoplay={true}
                            items={5}
                            margin={50}
                            dots={false}>
                                {
                                    content.map((item, index) => (
                                        <div className="single-logo-wrapper" key={index}>
                                            <div className="logo-inner-item">
                                                <img src={item.image} alt={item.image}/>
                                            </div>
                                        </div> 
                                    ))
                                }
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </div>                  
    )
}

export default OurDoners
